<span class="badge pedido-fracionado-badge"
    [title]="title"
    [ngStyle]="styles">
    <i class="fas fa-box-open"></i>
    <span *ngIf="label">
        {{label}}
    </span>
</span>